<template>
  <div class="content search_content">
    <v-row class="search_box">
      <v-col>
        <searchBar @getKey="getKey"></searchBar>
      </v-col>
    </v-row>
    <div class="manager_content_wrapper" v-cloak>
      <div class="manager_overlay_wrapper">
        <v-overlay :absolute="absolute" :value="itemLoading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
          <div class="text_center">数据加载中...</div>
        </v-overlay>
      </div>
      <div class="tit_name">专利管家</div>
      <div v-if="compItems && compItems.length > 0">
        <div class="content_top_wrapper">
          <div class="top_left">
            <div class="name">当前管理对象</div>
            <div class="common_input_style input_style">
              <v-select
                :items="compItems"
                label=""
                @change="compChange"
                v-model="keyWord"
                item-text="name"
                item-value="id"
                :dense="true"
                outlined
                hide-details
              >
              </v-select>
            </div>
            <v-tooltip top content-class="manager_tooltip_wrapper">
              <template v-slot:activator="{ on, attrs }">
                <div class="add_btn" @click="addManager" title="添加管理对象">
                  <v-icon v-bind="attrs" v-on="on">mdi-plus</v-icon>
                </div>
              </template>
              <span class="white_color">添加管理对象</span>
            </v-tooltip>
          </div>
          <div class="top_right">
            <v-tooltip top content-class="manager_tooltip_wrapper">
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hand" v-bind="attrs" v-on="on" @click="goSetting"
                  >mdi-cog</v-icon
                >
              </template>
              <span class="white_color">设置对象</span>
            </v-tooltip>
          </div>
        </div>
        <div class="content_center_wrapper">
          <div class="center_top">
            <div class="fix_btns" v-if="activeKey == 0">
              <span class="btn_item" @click="exportAll">导出全部专利</span>
              <span v-if="false" class="btn_item msg_btn" @click="goMsgSet"
                >消息提醒设置</span
              >
              <span class="btn_item" v-if="false">导出缴费清单</span>
            </div>
            <v-tabs @change="tabChange" v-model="activeKey">
              <v-tab key="0" class="spe"
                ><i class="icon chart_icon"></i> 概览统计</v-tab
              >
              <div class="line_gap"></div>
              <v-tab key="1">全部专利</v-tab>
              <v-tab key="2">已监控</v-tab>
              <v-tab key="3">未监控</v-tab>
              <v-tab key="2" v-if="false">有效专利</v-tab>
              <v-tab key="3" v-if="false">申请中</v-tab>
              <v-tab key="4" v-if="false">无效专利</v-tab>
              <v-tab key="5" v-if="false">专利权转移</v-tab>
              <v-tab-item key="0">
                <div class="manager_overlay_wrapper">
                  <v-overlay :absolute="absolute" :value="loading1">
                    <v-progress-circular
                      indeterminate
                      size="64"
                    ></v-progress-circular>
                    <div class="text_center">{{ tipsInfo }}</div>
                  </v-overlay>
                </div>
                <div class="content_tabitem_wrapper">
                  <div class="top_box_wrapper">
                    <div class="top_box1">
                      <div class="item_wrapper">
                        <div class="left_icon"></div>
                        <div class="right_text hand" @click="numChange(1)">
                          <div class="num">{{ numTotal || 0 }}</div>
                          <div class="text">专利总数</div>
                        </div>
                      </div>
                    </div>
                    <div class="top_box2">
                      <div class="item_wrapper">
                        <div class="three_item_box">
                          <div class="item_box first">
                            <div class="left_icon valid_icon"></div>
                            <div class="right_text hand" @click="numChange(2)">
                              <div class="num">
                                {{ numInfo["GRANTED"] || 0 }}
                              </div>
                              <div class="text">有效专利</div>
                            </div>
                            <div class="line"></div>
                          </div>
                          <div class="item_box second">
                            <div class="left_icon apply_icon"></div>
                            <div class="right_text hand" @click="numChange(3)">
                              <div class="num">
                                {{ numInfo["APPLYING"] || 0 }}
                              </div>
                              <div class="text">申请中</div>
                            </div>
                            <div class="line"></div>
                          </div>
                          <div class="item_box third">
                            <div class="left_icon invalid_icon"></div>
                            <div class="right_text hand" @click="numChange(4)">
                              <div class="num">
                                {{ numInfo["INVALID"] || 0 }}
                              </div>
                              <div class="text">无效专利</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="center_box_wrapper first">
                    <div class="item_wrapper">
                      <div class="item">
                        <div class="tit">专利分布</div>
                        <div class="chart_dom" ref="dom1" id="dom1"></div>
                      </div>
                    </div>
                    <div class="item_wrapper">
                      <div class="item">
                        <div class="tit">有效专利缴费情况</div>
                        <div class="list_dom">
                          <div
                            class="line_dom"
                            :class="{
                              red1: item.key == '待缴费',
                              teal1: item.key == '超期',
                              cyan1: item.key == '滞纳',
                              indigo1: item.key == '紧急',
                            }"
                            v-for="(item, index) in this.data2"
                            :key="index"
                          >
                            <div class="text">{{ item.key }}</div>
                            <div class="line_progress">
                              <v-progress-linear
                                color="darken-2"
                                rounded
                                height="12"
                                :value="item.percent"
                              ></v-progress-linear>
                            </div>
                            <div class="num">
                              <b>{{ item.value }}</b
                              >条
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="item_wrapper">
                      <div class="item">
                        <div class="tit">专利类型分布</div>
                        <div class="chart_dom" ref="dom3" id="dom3"></div>
                      </div>
                    </div>
                  </div>
                  <div class="center_box_wrapper">
                    <div class="item_wrapper">
                      <div class="item">
                        <div class="tit">核心技术布局</div>
                        <div class="chart_dom" ref="dom4" id="dom4"></div>
                      </div>
                    </div>
                    <div class="item_wrapper">
                      <div class="item">
                        <div class="tit">当前法律状态分布</div>
                        <div class="chart_dom" ref="dom5" id="dom5"></div>
                      </div>
                    </div>
                    <div class="item_wrapper">
                      <div class="item">
                        <div class="tit">发明人排行</div>
                        <div class="chart_dom" ref="dom6" id="dom6"></div>
                      </div>
                    </div>
                  </div>
                  <div class="center_box_wrapper">
                    <div class="item_wrapper">
                      <div class="item">
                        <div class="tit">专利申请/授权趋势</div>
                        <div class="chart_dom" ref="dom7" id="dom7"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item key="1">
                <div class="content_tabitem_wrapper">
                  <div class="tabitem_top_wrapper">
                    <div class="tabitem_filter">
                      <div class="item sel_item">
                        <div class="label">专利类型</div>
                        <div class="common_input_style">
                          <v-select
                            :items="typeList"
                            label=""
                            v-model="type1"
                            @change="filterKeyChange"
                            item-text="label"
                            item-value="value"
                            :dense="true"
                            outlined
                            hide-details
                          >
                          </v-select>
                        </div>
                      </div>
                      <div class="item sel_item">
                        <div class="label">专利状态</div>
                        <div class="common_input_style">
                          <v-select
                            :items="statusList"
                            label=""
                            v-model="status1"
                            @change="filterKeyChange"
                            item-text="label"
                            item-value="value"
                            :dense="true"
                            outlined
                            hide-details
                          >
                          </v-select>
                        </div>
                      </div>
                      <div class="item">
                        <div class="label">申请日</div>
                        <div class="dateChange_wrapper">
                          <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <div class="common_input_style1">
                                <v-text-field
                                  v-model="appDate1.date"
                                  label=""
                                  prepend-icon="mdi-calendar-range"
                                  readonly
                                  placeholder="选择申请日时间段"
                                  hide-details
                                  @click:clear="dateChange('appDate1')"
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </div>
                            </template>
                            <v-date-picker
                              v-model="appDate1.date"
                              @change="datePickChange(1)"
                              range
                            ></v-date-picker>
                            <!-- @input="menu1 = false" -->
                          </v-menu>
                        </div>
                      </div>
                      <div class="item">
                        <div class="label">缴费截止日</div>
                        <div class="dateChange_wrapper">
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <div class="common_input_style1">
                                <v-text-field
                                  v-model="feeDate1.date"
                                  label=""
                                  prepend-icon="mdi-calendar-range"
                                  readonly
                                  @click:clear="dateChange('feeDate1')"
                                  placeholder="选择缴费截止时间段"
                                  clearable
                                  hide-details
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                ></v-text-field>
                              </div>
                            </template>
                            <v-date-picker
                              v-model="feeDate1.date"
                              @change="datePickChange(2)"
                              range
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                    <div class="flex_style left simple_search">
                      <div class="input_box">
                        <v-text-field
                          label=""
                          v-model="filKey1"
                          solo
                          placeholder="专利名称/申请号/发明人"
                          hide-details
                          hide-selected
                        ></v-text-field>
                      </div>
                      <div class="right_btn hand" @click="filterKeyChange">
                        <span class="text">
                          <v-icon>mdi-magnify</v-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="tabitem_center_wrapper" v-if="activeKey != 0">
                    <div class="desp_text">
                      <span>当前搜索结果：专利</span>
                      <span class="colored">{{ totalNum }}条</span>
                      <span> ，需缴纳费用</span>
                      <span class="colored">{{ totalAmount }}元</span>
                    </div>
                    <div class="flex_style right">
                      <!-- <div class="btn_item"
                           @click="exportAll">导出全部专利</div> -->
                      <div class="btn_item1 type1" @click="exportAll">
                        <i class="icon"></i><span>导出专利</span>
                      </div>
                      <div class="btn_item1 type3" @click="goMsgSet">
                        <i class="icon"></i><span>消息提醒</span>
                      </div>
                      <div class="btn_item1 type4">
                        <i class="icon" @click="monitorPatent('all')"></i>
                        <!-- <span class="text" @click="monitorPatent('all')"
                          >全部监控</span
                        > -->
                          <span class="text" @click="monitorPatent('all')"
                          >全部监控</span
                        >
                        <i class="line"></i>
                        <v-menu offset-y content-class="mamager_dump">
                          <template v-slot:activator="{ on, attrs }">
                            <div class="trangle_icon" v-bind="attrs" v-on="on">
                              <i class="icon"></i>
                            </div>
                          </template>
                          <v-list>
                            <v-list-item @click="batchMonitor(selectedItem1)">
                              <v-list-item-title>
                                <div class="list_text">
                                  <span class="icon monitor"></span>
                                  <span class="text">批量监控专利</span>
                                </div>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="batchCancel(selectedItem1)">
                              <v-list-item-title>
                                <div class="list_text">
                                  <span class="icon cancel"></span>
                                  <span class="text">批量取消监控</span>
                                </div>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="batchDelete(selectedItem1)">
                              <v-list-item-title>
                                <div class="list_text">
                                  <span class="icon delete"></span>
                                  <span class="text">批量删除专利</span>
                                </div>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                      <!-- <span class="btn_item msg_btn" @click="goMsgSet">消息提醒设置</span> -->
                      <!-- <v-btn :loading="loading2"
                             class="btn_item green"
                             @click="monitorPatent('all')">监控全部专利</v-btn> -->
                    </div>
                  </div>
                  <div class="tabitem_table_wrapper">
                    <v-data-table
                      item-key="id"
                      v-model="selectedItem1"
                      :headers="headers"
                      :items="list"
                      :loading="loading"
                      class="common_table"
                      no-data-text="暂无数据"
                      disable-pagination
                      show-select
                      hide-default-footer
                    >
                      <!-- <template v-slot:header.fee="{header}"> -->
                      <template v-slot:[`header.fee`]="{ header }">
                        <v-tooltip top content-class="manager_tooltip_wrapper1">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="question_icon_wrapper"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <span class="text">{{ header.text }}</span>
                              <div class="icon"></div>
                            </div>
                          </template>
                          <span class="text1">专利缴费信息每周更新</span>
                        </v-tooltip>
                      </template>
                      <template
                        v-slot:item="{
                          index,
                          headers,
                          item,
                          isSelected,
                          select,
                        }"
                      >
                        <tr>
                          <td
                            class="text-start"
                            :width="item1.width"
                            v-for="(item1, index1) in headers"
                            :key="index1"
                          >
                            <div
                              class="tit_overflow"
                              v-if="item1.value == 'data-table-select'"
                            >
                              <div>
                                <v-simple-checkbox
                                  :value="isSelected"
                                  @input="select($event)"
                                ></v-simple-checkbox>
                              </div>
                            </div>
                            <div class="" v-else-if="item1.value == 'index'">
                              {{ index + 1 }}
                            </div>
                            <div class="" v-else-if="item1.value == 'actions'">
                              <div
                                v-if="
                                  item.monitorStatus == 'MONITORING' &&
                                  item.legalStatus != '无效专利' &&
                                  item.legalStatus != '失效专利'
                                "
                                @click="singleMonitor(item)"
                              >
                                <span class="text_green hand">立即监控</span>
                              </div>
                              <div
                                v-else-if="
                                  item.legalStatus == '无效专利' ||
                                  item.legalStatus == '失效专利'
                                "
                              >
                                <span
                                  class="text_blue hand"
                                  @click="singleDelete(item.id)"
                                  >删除专利</span
                                >
                              </div>
                              <div v-else-if="item.monitorStatus == 'EXPIRED'">
                                已过期
                              </div>
                              <div v-else>
                                <span
                                  class="text_blue hand"
                                  @click="watchPatent(item)"
                                  >费用</span
                                >
                                <v-menu offset-y content-class="mamager_dump">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span
                                      class="text_blue hand marl16"
                                      v-bind="attrs"
                                      v-on="on"
                                      >更多</span
                                    >
                                  </template>
                                  <v-list>
                                    <v-list-item @click="singleCancel(item.id)">
                                      <v-list-item-title>
                                        <div class="list_text">
                                          <span class="icon cancel"></span>
                                          <span class="text">取消监控</span>
                                        </div>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="singleDelete(item.id)">
                                      <v-list-item-title>
                                        <div class="list_text">
                                          <span class="icon delete"></span>
                                          <span class="text">删除专利</span>
                                        </div>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </div>
                            </div>
                            <div class="hand" v-else-if="item1.value == 'fee'">
                              <span class="red_color" v-if="item[item1.value]">
                                {{ item[item1.value] }}
                              </span>
                              <span class="red_color" v-else-if="item[lastFee]">
                                {{ item[lastFee] }}(滞纳)
                              </span>
                              <span class="black_color" v-else>--</span>
                            </div>
                            <div
                              class=""
                              v-else-if="item1.value == 'applicationDate'"
                            >
                              {{ timeFormat(item[item1.value]) }}
                            </div>
                            <div @click="goDetail(item)" class="hand" v-else>
                              <span v-if="item[item1.value]">{{
                                item[item1.value]
                              }}</span>
                              <span v-else>--</span>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <!-- <template v-slot:item.applicationDate="{item}">
                                            <div>
                                                {{timeFormat(item.applicationDate)}}
                                            </div>
                                        </template>
                                        <template v-slot:item.monitorDate="{item}">
                                           <div>
                                               {{timeFormat(item.monitorDate)}}
                                           </div>
                                        </template>
                                        <template v-slot:item.actions="{item}">
                                            <div class="overflow2" @click="watchPatent(item)">
                                                <span class="text_blue">费用明细</span>
                                            </div>
                                        </template> -->
                    </v-data-table>
                    <div class="flex_style center custom_pagination">
                      <span class="text hidden-xs-only"
                        >共 {{ total }} 条记录</span
                      >
                      <v-pagination
                        v-model="page"
                        :length="length"
                        :total-visible="7"
                      >
                      </v-pagination>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item key="2">
                <div class="content_tabitem_wrapper">
                  <div class="tabitem_top_wrapper">
                    <div class="tabitem_filter">
                      <div class="item sel_item">
                        <div class="common_input_style">
                          <v-select
                            :items="typeList"
                            label=""
                            v-model="type2"
                            @change="filterKeyChange"
                            item-text="label"
                            item-value="value"
                            :dense="true"
                            outlined
                            hide-details
                          >
                          </v-select>
                        </div>
                      </div>
                      <div class="item sel_item">
                        <div class="label">专利状态</div>
                        <div class="common_input_style">
                          <v-select
                            :items="statusList"
                            label=""
                            v-model="status2"
                            @change="filterKeyChange"
                            item-text="label"
                            item-value="value"
                            :dense="true"
                            outlined
                            hide-details
                          >
                          </v-select>
                        </div>
                      </div>
                      <div class="item">
                        <div class="label">申请日</div>
                        <div class="dateChange_wrapper">
                          <v-menu
                            v-model="menu3"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <div class="common_input_style1">
                                <v-text-field
                                  v-model="appDate2.date"
                                  label=""
                                  prepend-icon="mdi-calendar-range"
                                  readonly
                                  hide-details
                                  @click:clear="dateChange('appDate2')"
                                  placeholder="选择申请日时间段"
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </div>
                            </template>
                            <v-date-picker
                              v-model="appDate2.date"
                              @change="datePickChange(3)"
                              range
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </div>
                      <div class="item">
                        <div class="label">缴费截止日</div>
                        <div class="dateChange_wrapper">
                          <v-menu
                            v-model="menu4"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <div class="common_input_style1">
                                <v-text-field
                                  v-model="feeDate2.date"
                                  label=""
                                  prepend-icon="mdi-calendar-range"
                                  readonly
                                  @click:clear="dateChange('feeDate2')"
                                  placeholder="选择缴费截止时间段"
                                  hide-details
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </div>
                            </template>
                            <v-date-picker
                              v-model="feeDate2.date"
                              @change="datePickChange(4)"
                              range
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                    <div class="flex_style left simple_search">
                      <div class="input_box">
                        <v-text-field
                          label=""
                          v-model="filKey2"
                          solo
                          placeholder="专利名称/申请号/发明人"
                          hide-details
                          dense
                          @keydown.enter="filterKeyChange"
                          @click:append="filterKeyChange"
                          hide-selected
                        ></v-text-field>
                      </div>
                      <div class="right_btn hand" @click="filterKeyChange">
                        <span class="text">
                          <v-icon>mdi-magnify</v-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="tabitem_center_wrapper" v-if="activeKey != 0">
                    <div class="desp_text">
                      <span>当前搜索结果：专利</span>
                      <span class="colored">{{ totalNum }}条</span>
                      <span> ，需缴纳费用</span>
                      <span class="colored">{{ totalAmount }}元</span>
                    </div>
                    <div class="flex_style right">
                      <!-- <div class="btn_item" @click="exportAll">导出全部专利</div> -->
                      <!-- <span class="btn_item msg_btn" @click="goMsgSet">消息提醒设置</span> -->
                      <div class="btn_item1 type1" @click="exportAll">
                        <i class="icon"></i><span>导出专利</span>
                      </div>
                      <div class="btn_item1 type2" @click="feeExport">
                        <i class="icon"></i><span>缴费清单</span>
                      </div>
                      <div class="btn_item1 type3" @click="goMsgSet">
                        <i class="icon"></i><span>消息提醒</span>
                      </div>
                      <div class="btn_item1 type4">
                        <i class="icon"></i>
                        <span class="text">批量操作</span>
                        <i class="line"></i>
                        <v-menu offset-y content-class="mamager_dump">
                          <template v-slot:activator="{ on, attrs }">
                            <div class="trangle_icon" v-bind="attrs" v-on="on">
                              <i class="icon"></i>
                            </div>
                          </template>
                          <v-list>
                            <v-list-item @click="batchCancel(selectedItem2)">
                              <v-list-item-title>
                                <div class="list_text">
                                  <span class="icon cancel"></span>
                                  <span class="text">批量取消监控</span>
                                </div>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="batchDelete(selectedItem2)">
                              <v-list-item-title>
                                <div class="list_text">
                                  <span class="icon delete"></span>
                                  <span class="text">批量删除专利</span>
                                </div>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                      <!-- <v-btn :loading="loading2"
                             class="btn_item green"
                             @click="monitorPatent('all')">监控全部专利</v-btn>-->
                    </div>
                  </div>
                  <div class="tabitem_table_wrapper">
                    <v-data-table
                      v-model="selectedItem2"
                      item-key="id"
                      :headers="headers"
                      :loading="loading"
                      :items="list"
                      no-data-text="暂无数据"
                      show-select
                      disable-pagination
                      hide-default-footer
                      class="common_table"
                    >
                      <!-- <template v-slot:header.fee="{ header }"> -->
                      <template v-slot:[`header.fee`]="{ header }">
                        <v-tooltip top content-class="manager_tooltip_wrapper1">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="question_icon_wrapper"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <span class="text">{{ header.text }}</span>
                              <div class="icon"></div>
                            </div>
                          </template>
                          <span class="text1">专利缴费信息每周更新</span>
                        </v-tooltip>
                      </template>
                      <template
                        v-slot:item="{
                          index,
                          headers,
                          item,
                          isSelected,
                          select,
                        }"
                      >
                        <tr>
                          <td
                            class="text-start"
                            :width="item1.width"
                            v-for="(item1, index1) in headers"
                            :key="index1"
                          >
                            <div
                              class="tit_overflow"
                              v-if="item1.value == 'data-table-select'"
                            >
                              <div>
                                <v-simple-checkbox
                                  :value="isSelected"
                                  @input="select($event)"
                                ></v-simple-checkbox>
                              </div>
                            </div>
                            <div class="" v-else-if="item1.value == 'index'">
                              {{ index + 1 }}
                            </div>
                            <div class="" v-else-if="item1.value == 'actions'">
                              <div
                                v-if="
                                  item.monitorStatus == 'MONITORING' &&
                                  item.legalStatus != '无效专利' &&
                                  item.legalStatus != '失效专利'
                                "
                                @click="singleMonitor(item)"
                              >
                                <span class="text_green hand">立即监控</span>
                              </div>
                              <div
                                v-else-if="
                                  item.legalStatus == '无效专利' ||
                                  item.legalStatus == '失效专利'
                                "
                              >
                                <span
                                  class="text_blue hand"
                                  @click="singleDelete(item.id)"
                                  >删除专利</span
                                >
                              </div>
                              <div
                                v-else-if="item.monitorStatus == 'EXPIRED'"
                                @click="singleDelete(item.id)"
                              >
                                删除专利
                              </div>
                              <div v-else>
                                <span
                                  class="text_blue hand"
                                  @click="watchPatent(item)"
                                  >费用</span
                                >
                                <v-menu offset-y content-class="mamager_dump">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span
                                      class="text_blue hand marl16"
                                      v-bind="attrs"
                                      v-on="on"
                                      >更多</span
                                    >
                                  </template>
                                  <v-list>
                                    <v-list-item @click="singleCancel(item.id)">
                                      <v-list-item-title>
                                        <div class="list_text">
                                          <span class="icon cancel"></span>
                                          <span class="text">取消监控</span>
                                        </div>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="singleDelete(item.id)">
                                      <v-list-item-title>
                                        <div class="list_text">
                                          <span class="icon delete"></span>
                                          <span class="text">删除专利</span>
                                        </div>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </div>
                            </div>
                            <div class="hand" v-else-if="item1.value == 'fee'">
                              <span
                                class="red_color"
                                v-if="item[item1.value]"
                                >{{ item[item1.value] }}</span
                              >
                              <span class="red_color" v-else-if="item[lastFee]">
                                {{ item[lastFee] }}(滞纳)
                              </span>
                              <span class="black_color" v-else>--</span>
                            </div>
                            <div
                              class=""
                              v-else-if="item1.value == 'applicationDate'"
                            >
                              {{ timeFormat(item[item1.value]) }}
                            </div>
                            <div @click="goDetail(item)" class="hand" v-else>
                              <span v-if="item[item1.value]">{{
                                item[item1.value]
                              }}</span>
                              <span v-else>--</span>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <!-- <template v-slot:item.applicationDate="{item}">
                                            <div>
                                                {{timeFormat(item.applicationDate)}}
                                            </div>
                                        </template>
                                        <template v-slot:item.monitorDate="{item}">
                                           <div>
                                               {{timeFormat(item.monitorDate)}}
                                           </div>
                                        </template>
                                        <template v-slot:item.actions="{item}">
                                            <div class="overflow2" @click="watchPatent(item)">
                                                <span class="text_blue">费用明细</span>
                                            </div>
                                        </template> -->
                    </v-data-table>
                    <div class="flex_style center custom_pagination">
                      <span class="text hidden-xs-only"
                        >共 {{ total }} 条记录</span
                      >
                      <v-pagination
                        v-model="page"
                        :length="length"
                        :total-visible="7"
                      >
                      </v-pagination>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item key="3">
                <div class="content_tabitem_wrapper">
                  <div class="tabitem_top_wrapper">
                    <div class="tabitem_filter">
                      <div class="item sel_item">
                        <div class="common_input_style">
                          <v-select
                            :items="typeList"
                            label=""
                            v-model="type3"
                            @change="filterKeyChange"
                            item-text="label"
                            item-value="value"
                            :dense="true"
                            outlined
                            hide-details
                          >
                          </v-select>
                        </div>
                      </div>
                      <div class="item sel_item">
                        <div class="label">专利状态</div>
                        <div class="common_input_style">
                          <v-select
                            :items="statusList"
                            label=""
                            v-model="status3"
                            @change="filterKeyChange"
                            item-text="label"
                            item-value="value"
                            :dense="true"
                            outlined
                            hide-details
                          >
                          </v-select>
                        </div>
                      </div>
                      <div class="item">
                        <div class="label">申请日</div>
                        <div class="dateChange_wrapper">
                          <v-menu
                            v-model="menu5"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <div class="common_input_style1">
                                <v-text-field
                                  v-model="appDate3.date"
                                  label=""
                                  prepend-icon="mdi-calendar-range"
                                  readonly
                                  @click:clear="dateChange('appDate3')"
                                  hide-details
                                  v-bind="attrs"
                                  placeholder="请选择申请日时间段"
                                  v-on="on"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </div>
                            </template>
                            <v-date-picker
                              v-model="appDate3.date"
                              @change="datePickChange(5)"
                              range
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </div>
                      <div class="item">
                        <div class="label">缴费截止日</div>
                        <div class="dateChange_wrapper">
                          <v-menu
                            v-model="menu6"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <div class="common_input_style1">
                                <v-text-field
                                  v-model="feeDate3.date"
                                  label=""
                                  prepend-icon="mdi-calendar-range"
                                  readonly
                                  @click:clear="dateChange('feeDate3')"
                                  hide-details
                                  placeholder="请选择缴费截止日时间段"
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </div>
                            </template>
                            <v-date-picker
                              v-model="feeDate3.date"
                              @change="datePickChange(6)"
                              range
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                    <div class="flex_style left simple_search">
                      <div class="input_box">
                        <v-text-field
                          label=""
                          v-model="filKey3"
                          solo
                          placeholder="专利名称/申请号/发明人"
                          hide-details
                          hide-selected
                        ></v-text-field>
                      </div>
                      <div class="right_btn hand" @click="filterKeyChange">
                        <span class="text">
                          <v-icon>mdi-magnify</v-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="tabitem_center_wrapper" v-if="activeKey != 0">
                    <div class="desp_text">
                      <span>当前搜索结果：专利</span>
                      <span class="colored">{{ totalNum }}条</span>
                      <span> ，需缴纳费用</span>
                      <span class="colored">{{ totalAmount }}元</span>
                    </div>
                    <div class="flex_style right">
                      <!-- <div class="btn_item" @click="exportAll">导出全部专利</div> -->
                      <!-- <span class="btn_item msg_btn" @click="goMsgSet">消息提醒设置</span> -->
                      <div class="btn_item1 type1" @click="exportAll">
                        <i class="icon"></i><span>导出专利</span>
                      </div>
                      <div class="btn_item1 type3" @click="goMsgSet">
                        <i class="icon"></i><span>消息提醒</span>
                      </div>
                      <div class="btn_item1 type4">
                        <i class="icon" @click="monitorPatent('all')"></i>
                        <span class="text" @click="monitorPatent('all')"
                          >全部监控</span
                        >
                        <i class="line"></i>
                        <v-menu offset-y content-class="mamager_dump">
                          <template v-slot:activator="{ on, attrs }">
                            <div class="trangle_icon" v-bind="attrs" v-on="on">
                              <i class="icon"></i>
                            </div>
                          </template>
                          <v-list>
                            <v-list-item @click="batchMonitor(selectedItem3)">
                              <v-list-item-title>
                                <div class="list_text">
                                  <span class="icon monitor"></span>
                                  <span class="text">批量监控专利</span>
                                </div>
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="batchDelete(selectedItem3)">
                              <v-list-item-title>
                                <div class="list_text">
                                  <span class="icon delete"></span>
                                  <span class="text">批量删除专利</span>
                                </div>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                      <!-- <v-btn :loading="loading2"
                             class="btn_item green"
                             @click="monitorPatent('all')">监控全部专利</v-btn> -->
                    </div>
                  </div>
                  <div class="tabitem_table_wrapper">
                    <v-data-table
                      v-model="selectedItem3"
                      item-key="id"
                      :loading="loading"
                      :headers="headers"
                      hide-default-footer
                      :items="list"
                      no-data-text="暂无数据"
                      show-select
                      disable-pagination
                      class="common_table"
                    >
                      <!-- <template v-slot:header.fee="{ header }"> -->
                      <template v-slot:[`header.fee`]="{ header }">
                        <v-tooltip top content-class="manager_tooltip_wrapper1">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="question_icon_wrapper"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <span class="text">{{ header.text }}</span>
                              <div class="icon"></div>
                            </div>
                          </template>
                          <span class="text1">专利缴费信息每周更新</span>
                        </v-tooltip>
                      </template>
                      <template
                        v-slot:item="{
                          index,
                          headers,
                          item,
                          isSelected,
                          select,
                        }"
                      >
                        <tr>
                          <td
                            class="text-start"
                            :width="item1.width"
                            v-for="(item1, index1) in headers"
                            :key="index1"
                          >
                            <div
                              class="tit_overflow"
                              v-if="item1.value == 'data-table-select'"
                            >
                              <div>
                                <v-simple-checkbox
                                  :value="isSelected"
                                  @input="select($event)"
                                ></v-simple-checkbox>
                              </div>
                            </div>
                            <div class="" v-else-if="item1.value == 'index'">
                              {{ index + 1 }}
                            </div>
                            <div class="" v-else-if="item1.value == 'actions'">
                              <div
                                v-if="
                                  item.monitorStatus == 'MONITORING' &&
                                  item.legalStatus != '无效专利' &&
                                  item.legalStatus != '失效专利'
                                "
                                @click="singleMonitor(item)"
                              >
                                <span class="text_green hand">立即监控</span>
                              </div>
                              <div
                                v-else-if="
                                  item.legalStatus == '无效专利' ||
                                  item.legalStatus == '失效专利'
                                "
                              >
                                <span
                                  class="text_blue hand"
                                  @click="singleDelete(item.id)"
                                  >删除专利</span
                                >
                              </div>
                              <div
                                v-else-if="item.monitorStatus == 'EXPIRED'"
                                @click="singleDelete(item.id)"
                              >
                                删除专利
                              </div>
                              <div v-else>
                                <span
                                  class="text_blue hand"
                                  @click="watchPatent(item)"
                                  >费用</span
                                >
                                <v-menu offset-y content-class="mamager_dump">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span
                                      class="text_blue hand marl16"
                                      v-bind="attrs"
                                      v-on="on"
                                      >更多</span
                                    >
                                  </template>
                                  <v-list>
                                    <v-list-item @click="singleCancel(item.id)">
                                      <v-list-item-title>
                                        <div class="list_text">
                                          <span class="icon cancel"></span>
                                          <span class="text">取消监控</span>
                                        </div>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="singleDelete(item.id)">
                                      <v-list-item-title>
                                        <div class="list_text">
                                          <span class="icon delete"></span>
                                          <span class="text">删除专利</span>
                                        </div>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </div>
                            </div>
                            <div class="hand" v-else-if="item1.value == 'fee'">
                              <span
                                class="red_color"
                                v-if="item[item1.value]"
                                >{{ item[item1.value] }}</span
                              >
                              <span class="red_color" v-else-if="item[lastFee]">
                                {{ item[lastFee] }}(滞纳)
                              </span>
                              <span class="black_color" v-else>--</span>
                            </div>
                            <div
                              class=""
                              v-else-if="item1.value == 'applicationDate'"
                            >
                              {{ timeFormat(item[item1.value]) }}
                            </div>
                            <div @click="goDetail(item)" class="hand" v-else>
                              <span v-if="item[item1.value]">{{
                                item[item1.value]
                              }}</span>
                              <span v-else>--</span>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <!-- <template v-slot:item.applicationDate="{item}">
                                            <div>
                                                {{timeFormat(item.applicationDate)}}
                                            </div>
                                        </template>
                                        <template v-slot:item.monitorDate="{item}">
                                           <div>
                                               {{timeFormat(item.monitorDate)}}
                                           </div>
                                        </template>
                                        <template v-slot:item.actions="{item}">
                                            <div class="overflow2" @click="watchPatent(item)">
                                                <span class="text_blue">费用明细</span>
                                            </div>
                                        </template> -->
                    </v-data-table>
                    <div class="flex_style center custom_pagination">
                      <span class="text hidden-xs-only"
                        >共 {{ total }} 条记录</span
                      >
                      <v-pagination
                        v-model="page"
                        :length="length"
                        :total-visible="7"
                      >
                      </v-pagination>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item key="4" v-if="false">
                <div class="content_tabitem_wrapper">
                  <div class="tabitem_top_wrapper">
                    <div class="tabitem_filter">
                      <div class="item sel_item">
                        <div class="common_input_style">
                          <v-select
                            :items="typeList"
                            label=""
                            v-model="type4"
                            @change="filterKeyChange"
                            item-text="label"
                            item-value="value"
                            :dense="true"
                            outlined
                            hide-details
                          >
                          </v-select>
                        </div>
                      </div>
                      <div class="item">
                        <div class="label">申请日</div>
                        <div class="dateChange_wrapper">
                          <v-menu
                            v-model="menu7"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <div class="common_input_style1">
                                <v-text-field
                                  v-model="appDate4.date"
                                  label=""
                                  prepend-icon="mdi-calendar-range"
                                  readonly
                                  @click:clear="dateChange('appDate4')"
                                  hide-details
                                  placeholder="请选择申请日时间段"
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </div>
                            </template>
                            <v-date-picker
                              v-model="appDate4.date"
                              @change="datePickChange(7)"
                              range
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                    <div class="flex_style left simple_search">
                      <div class="input_box">
                        <v-text-field
                          label=""
                          v-model="filKey4"
                          solo
                          placeholder="专利名称/申请号/发明人"
                          hide-details
                          hide-selected
                        ></v-text-field>
                      </div>
                      <div class="right_btn hand" @click="filterKeyChange">
                        <span class="text">
                          <v-icon>mdi-magnify</v-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="tabitem_center_wrapper" v-if="activeKey != 0">
                    <div class="desp_text">
                      <span>当前搜索结果：专利</span>
                      <span class="colored">{{ totalNum }}条</span>
                      <span> ，需缴纳费用</span>
                      <span class="colored">{{ totalAmount }}元</span>
                    </div>
                    <div class="flex_style right">
                      <div class="btn_item" @click="exportAll">
                        导出全部专利
                      </div>
                      <span class="btn_item msg_btn" @click="goMsgSet"
                        >消息提醒设置</span
                      >
                    </div>
                  </div>
                  <div class="tabitem_table_wrapper">
                    <v-data-table
                      v-model="selectedItem"
                      item-key="id"
                      :loading="loading"
                      :headers="headers1"
                      disable-pagination
                      hide-default-footer
                      :items="list"
                      no-data-text="暂无数据"
                      class="common_table"
                    >
                      <template v-slot:item="{ index, headers, item }">
                        <tr>
                          <td
                            class="text-start"
                            :width="item1.width"
                            v-for="(item1, index1) in headers"
                            :key="index1"
                          >
                            <div class="" v-if="item1.value == 'index'">
                              {{ index + 1 }}
                            </div>
                            <div
                              class=""
                              v-else-if="item1.value == 'applicationDate'"
                            >
                              {{ timeFormat(item[item1.value]) }}
                            </div>
                            <div @click="goDetail(item)" class="hand" v-else>
                              <span v-if="item[item1.value]">{{
                                item[item1.value]
                              }}</span>
                              <span v-else>--</span>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <!-- <template v-slot:item.applicationDate="{item}">
                                           <div>
                                               {{timeFormat(item.applicationDate)}}
                                           </div>
                                        </template> -->
                    </v-data-table>
                    <div class="flex_style center custom_pagination">
                      <span class="text hidden-xs-only"
                        >共 {{ total }} 条记录</span
                      >
                      <v-pagination
                        v-model="page"
                        :length="length"
                        :total-visible="7"
                      >
                      </v-pagination>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item key="5" v-if="false">
                <div class="content_tabitem_wrapper">
                  <div class="tabitem_top_wrapper">
                    <div class="tabitem_filter">
                      <div class="item sel_item">
                        <div class="common_input_style">
                          <v-select
                            :items="typeList"
                            label=""
                            v-model="type5"
                            @change="filterKeyChange"
                            item-text="label"
                            item-value="value"
                            :dense="true"
                            outlined
                            hide-details
                          >
                          </v-select>
                        </div>
                      </div>
                      <div class="item">
                        <div class="dateChange_wrapper">
                          <div class="label">申请日</div>
                          <v-menu
                            v-model="menu8"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <div class="common_input_style1">
                                <v-text-field
                                  v-model="appDate5.date"
                                  label=""
                                  prepend-icon="mdi-calendar-range"
                                  readonly
                                  @click:clear="dateChange('appDate5')"
                                  hide-details
                                  placeholder="请选择申请日时间段"
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </div>
                            </template>
                            <v-date-picker
                              v-model="appDate5.date"
                              @change="datePickChange(8)"
                              range
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                    <div class="flex_style left simple_search">
                      <div class="input_box">
                        <v-text-field
                          label=""
                          v-model="filKey5"
                          solo
                          placeholder="专利名称/申请号/发明人"
                          hide-details
                          hide-selected
                        ></v-text-field>
                      </div>
                      <div class="right_btn hand" @click="filterKeyChange">
                        <span class="text">
                          <v-icon>mdi-magnify</v-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="tabitem_table_wrapper">
                    <v-data-table
                      v-model="selectedItem"
                      item-key="id"
                      :loading="loading"
                      :headers="headers1"
                      :items="list"
                      no-data-text="暂无数据"
                      disable-pagination
                      hide-default-footer
                      class="common_table"
                    >
                      <template v-slot:item="{ index, headers, item }">
                        <tr>
                          <td
                            class="text-start"
                            :width="item1.width"
                            v-for="(item1, index1) in headers"
                            :key="index1"
                          >
                            <div class="" v-if="item1.value == 'index'">
                              {{ index + 1 }}
                            </div>
                            <div
                              class=""
                              v-else-if="item1.value == 'applicationDate'"
                            >
                              {{ timeFormat(item[item1.value]) }}
                            </div>
                            <div @click="goDetail(item)" class="hand" v-else>
                              {{ item[item1.value] }}
                            </div>
                          </td>
                        </tr>
                      </template>
                      <!-- <template v-slot:item.applicationDate="{item}">
                                                <div>
                                                    {{timeFormat(item.applicationDate)}}
                                                </div>
                                            </template> -->
                    </v-data-table>
                    <div class="flex_style center custom_pagination">
                      <span class="text hidden-xs-only"
                        >共 {{ total }} 条记录</span
                      >
                      <v-pagination
                        v-model="page"
                        :length="length"
                        :total-visible="7"
                      >
                      </v-pagination>
                    </div>
                  </div>
                </div>
              </v-tab-item>
            </v-tabs>
          </div>
        </div>
      </div>
      <div class="empty_content_wrapper" v-else>
        <div class="add_btn_wrapper">
          <div class="btn_item" @click="addManager">
            <v-icon>mdi-plus</v-icon>
            <span class="text">添加管理对象</span>
          </div>
        </div>
        <div class="content_wrapper">
          <div class="content_box">
            <div class="left_content">
              <div class="tit_name">专利管家如何使用？</div>
              <div class="text_cons">
                一键添加管理对象，同时监控专利年费和专利状态，并通过短信、邮件方式适时提醒用户缴费事宜和专利状态变更信息
              </div>
              <div class="flex_style left">
                <router-link to="/help" target="_blank">
                  <div class="btn_items blue1">
                    <div class="flex_style left">
                      <span class="icon"></span>
                      <span class="text">监控专利年费</span>
                    </div>
                    <v-icon>mdi-chevron-right</v-icon>
                  </div>
                </router-link>
                <router-link to="/help" target="_blank">
                  <div class="btn_items green1">
                    <div class="flex_style left">
                      <span class="icon"></span>
                      <span class="text">监控专利年费</span>
                    </div>
                    <v-icon>mdi-chevron-right</v-icon>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="right_content">
              <img src="../../assets/images/icons/help_img4.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="addDialog" width="600">
      <v-card>
        <v-card-title
          ><span class="fontbold font18">添加管理对象</span>
          <v-icon @click="handleAddCancel">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="addSpace_wrapper addManager_wrappper">
            <div class="common_input_style">
              <!-- <v-text-field
                                hide-details="auto"
                                outlined
                                placeholder="请输入您的企业名称"
                                v-model="form.companyName"
                            ></v-text-field> -->
              <v-combobox
                v-model="compName"
                :items="compNameItems"
                label="请输入您的企业名称"
                append-icon=""
                :search-input.sync="search"
                clearable
                light
                outlined
                hide-details
                hide-selected
              >
              </v-combobox>
            </div>
            <div class="common_line_style" v-if="false">
              <v-checkbox
                v-model="form.flag"
                label="开启专利年费、年费变化消息通知"
              ></v-checkbox>
            </div>
            <div class="common_input_style marb12" v-if="false">
              <v-text-field
                hide-details="auto"
                outlined
                placeholder="请输入通知对象名称"
                v-model="form.name"
              ></v-text-field>
            </div>
            <div class="common_input_style marb12" v-if="false">
              <v-text-field
                hide-details="auto"
                outlined
                placeholder="请输入通知对象手机号"
                v-model="form.phone"
              ></v-text-field>
            </div>
            <div class="common_input_style" v-if="false">
              <v-text-field
                hide-details="auto"
                outlined
                placeholder="请输入通知对象邮箱（选填）"
                v-model="form.email"
              ></v-text-field>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleAddCancel">取消</v-btn>
          <v-btn color="primary" @click="handleAddOk">提交</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="feeDialog" width="70%">
      <v-card>
        <v-card-title
          ><span class="fontbold font18">查询费用信息</span>
          <v-icon @click="handleFeeCancel">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div>
            <v-overlay :absolute="absolute" :value="feeLoading">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
              <div class="white_color">正在获取费用明细，请耐心等待</div>
            </v-overlay>
            <div class="addSpace_wrapper feeInfo_wrapper">
              <div class="fee_top_wrapper marb20">
                <div class="flex_style left marb6">
                  <div class="line_style_item">
                    <div class="label">费用信息查询时间：</div>
                    <div class="value">
                      {{ timeFormat(feeInfo.monitorDate) }}
                    </div>
                  </div>
                  <div class="line_style_item">
                    <div class="label">专利号：</div>
                    <div class="value">{{ feeInfo.documentNumber }}</div>
                  </div>
                </div>
                <div class="flex_style left">
                  <div class="line_style_item">
                    <div class="label">专利名称：</div>
                    <div class="value">{{ feeInfo.title }}</div>
                  </div>
                  <div class="line_style_item">
                    <div class="label">法律状态：</div>
                    <div class="value">{{ feeInfo.legalStatus }}</div>
                  </div>
                </div>
              </div>
              <div class="fee_center_wrapper">
                <div class="tit_name">未缴费信息</div>
                <div class="table_line_wrapper">
                  <div class="table_box">
                    <div class="tr header">
                      <div class="td">费用种类</div>
                      <div class="td">应缴金额（元）</div>
                      <div class="td">缴费截止日</div>
                      <div class="td">费用状态</div>
                    </div>
                    <div
                      class="tr"
                      v-for="(item, index) in feeData1"
                      :key="index"
                    >
                      <div class="td">{{ item.feeType }}</div>
                      <div class="td">{{ item.amount }}</div>
                      <div class="td">{{ item.date }}</div>
                      <div class="td" v-if="item.state">{{ item.state }}</div>
                      <div class="td" v-else>未知</div>
                    </div>
                  </div>
                </div>
                <div class="tit_name">已缴费信息</div>
                <div class="table_line_wrapper">
                  <div class="table_box">
                    <div class="tr header">
                      <div class="td">费用种类</div>
                      <div class="td">应缴金额（元）</div>
                      <div class="td">缴费截止日</div>
                      <div class="td">费用状态</div>
                    </div>
                    <div
                      class="tr"
                      v-for="(item, index) in feeData2"
                      :key="index"
                    >
                      <div class="td">{{ item.feeType }}</div>
                      <div class="td">{{ item.amount }}</div>
                      <div class="td">{{ item.date }}</div>
                      <div class="td">已缴费</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="monitorVisible" width="450">
      <v-card>
        <v-card-title
          ><span class="fontbold font18">监控提示</span>
          <v-icon @click="monitorVisible = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="monitorTips_wrapper">
            <div class="img_icon"></div>

            <div class="contact_tips">
              {{tipMessage}}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="monitorVisible1" width="570">
      <v-card>
        <v-card-title
          ><span class="fontbold font18">监控提示</span>
          <v-icon @click="monitorVisible1 = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="monitorTips_wrapper">
            <div class="img_icon success1"></div>
            <div class="tips_text">添加监控成功</div>
            <div class="tips_info1">
              <div class="info1">
                <div class="grey1">本次添加监控：</div>
                <div class="blue1">{{ watchNum }}个</div>
              </div>
              <div class="line"></div>
              <div class="info1">
                <div class="grey1">添加监控上限：</div>
                <div class="orange1">{{residueNum}}</div>
              </div>
            </div>
            <div class="tips_box2" v-if="peopleList.length <= 0">
              <div class="btn_item" @click="addObject">
                <v-icon>mdi-plus</v-icon>
                <span class="text">添加监控提醒，及时获取年费信息</span>
              </div>
            </div>
            <div class="tips_box1" v-if="false">
              <div class="text">
                为及时通知您专利监控情况，您可通过添加联系人来获取消息提醒
              </div>
              <div class="btn_item" @click="addObject">立即添加</div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="personDialog" width="500">
      <v-card>
        <v-card-title
          ><span class="fontbold font18">添加通知人 </span>
          <v-icon @click="handlePersonCancel">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="addSpace_wrapper addManager_wrappper">
            <div class="common_input_style marb30">
              <v-text-field
                hide-details="auto"
                outlined
                placeholder="请输入通知人的姓名"
                label="姓名"
                v-model="form1.name"
              ></v-text-field>
            </div>
            <div class="common_input_style marb30">
              <v-text-field
                hide-details="auto"
                outlined
                placeholder="请输入通知人的手机号"
                v-model="form1.webChat"
                label="手机号"
              ></v-text-field>
            </div>
            <div class="common_input_style">
              <v-text-field
                hide-details="auto"
                outlined
                placeholder="请输入通知人的邮箱"
                v-model="form1.email"
                label="邮箱"
              ></v-text-field>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handlePersonCancel">取消</v-btn>
          <v-btn color="primary" @click="handlePersonAddOk">提交</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
[v-cloak] {
  display: none;
}
</style>
<script>
import searchBar from "@/components/widgets/searchBar.vue";
import { mapActions, mapState } from "vuex";
import echarts from "echarts";
import Qs from 'qs'
export default {
  data() {
    return {
      feeLoading: false,
      loading: false,
      keyWord: "",
      lastFee:"",
      APPLYING:"",
      monitorStatus: "",
      activeKey: 0,
      compItems: [],
      itemLoading: false,
      typeList: [
        {
          label: "类型不限",
          value: "",
        },
        {
          label: "发明专利",
          value: "发明专利",
        },
        {
          label: "实用新型",
          value: "实用新型",
        },
        {
          label: "外观设计",
          value: "外观设计",
        },
      ],
      statusList: [
        {
          label: "状态不限",
          value: "",
        },
        {
          label: "有效",
          value: "granted",
        },
        {
          label: "申请中",
          value: "applying",
        },
        {
          label: "无效",
          value: "invalid",
        },
      ],
      feeList: [
        {
          label: "不限",
          value: "none",
        },
        {
          label: "已缴费",
          value: "invent",
        },
        {
          label: "待缴费",
          value: "unity",
        },
        {
          label: "紧急",
          value: "design",
        },
        {
          label: "滞纳",
          value: "designww",
        },
      ],
      date: new Date().toISOString().substr(0, 10),
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date3: new Date().toISOString().substr(0, 10),
      date4: new Date().toISOString().substr(0, 10),
      date5: new Date().toISOString().substr(0, 10),
      date6: new Date().toISOString().substr(0, 10),
      date7: new Date().toISOString().substr(0, 10),
      date8: new Date().toISOString().substr(0, 10),
      appDate1: {},
      feeDate1: {},
      appDate2: {},
      feeDate2: {},
      appDate3: {},
      feeDate3: {},
      appDate4: {},
      appDate5: {},
      tipMessage:'',
      residueNum:'',
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      menu8: false,
      type1: "",
      type2: "",
      type3: "",
      type4: "",
      type5: "",
      status1: "",
      status2: "",
      status3: "",
      feeStatus: "",
      myChart1: "",
      myChart7: "",
      myChart3: "",
      myChart4: "",
      myChart5: "",
      myChart6: "",
      dataAxis: [],
      data9: {
        apply: [211, 202, 266, 294, 363, 609, 860, 1050, 1204, 1537, 657],
        total: [121, 211, 175, 220, 255, 422, 540, 635, 783, 942, 1319],
        invent: [27, 29, 23, 22, 25, 45, 68, 90, 83, 111, 92],
        ultiy: [48, 112, 97, 159, 185, 284, 351, 435, 553, 658, 914],
        design: [46, 70, 55, 39, 45, 93, 121, 110, 147, 173, 313],
      },
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      data6: [],
      data7: [],
      addDialog: false,
      form: {},
      selectedItem: [],
      headers: [
        {
          text: "序号",
          align: "start",
          sortable: false,
          width: "54px",
          value: "index",
        },
        {
          text: "申请号",
          align: "start",
          sortable: false,
          value: "applicationNumber",
        },
        {
          text: "专利名称",
          align: "start",
          sortable: false,
          value: "title",
        },
        {
          text: "专利类型",
          align: "start",
          sortable: false,
          value: "patentType",
        },
        {
          text: "专利状态",
          align: "start",
          sortable: false,
          value: "currentStatus",
        },
        {
          text: "申请人",
          align: "start",
          sortable: false,
          value: "applicant",
        },
        {
          text: "申请日",
          align: "start",
          sortable: false,
          value: "applicationDate",
        },
        {
          text: "缴费截止日",
          align: "start",
          sortable: false,
          value: "deadlineString",
        },
        {
          text: "应缴费",
          align: "start",
          sortable: false,
          value: "fee",
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          width: "100px",
          value: "actions",
        },
      ],
      headers1: [
        {
          text: "序号",
          align: "start",
          sortable: false,
          width: "54px",
          value: "index",
        },
        {
          text: "申请号",
          align: "start",
          sortable: false,
          value: "applicationNumber",
        },
        {
          text: "专利名称",
          align: "start",
          sortable: false,
          value: "title",
        },
        {
          text: "专利类型",
          align: "start",
          sortable: false,
          value: "patentType",
        },
        {
          text: "专利状态",
          align: "start",
          sortable: false,
          value: "currentStatus",
        },
        {
          text: "申请日",
          align: "start",
          sortable: false,
          value: "applicationDate",
        },
        {
          text: "专利权人",
          align: "start",
          sortable: false,
          value: "assignee",
        },
      ],
      list: [],
      compNameItems: [],
      compName: "",
      search: "",
      feeDialog: false,
      total: 0,
      page: 1,
      length: 0,
      currentpage: 1,
      stage: "",
      m: "",
      pageSize: 20,
      patentType: "",
      filterKey: "",
      filKey1: "",
      filKey2: "",
      filKey3: "",
      filKey4: "",
      filKey5: "",
      applicationDateStart: "",
      applicationDateEnd: "",
      numInfo: {},
      numTotal: 0,
      feeInfo: {},
      feeData1: [],
      feeData2: [],
      loading1: false,
      absolute: true,
      overlay: false,
      tipsInfo: "",
      deadlineStart: "",
      deadlineEnd: "",
      numCalc: 0,
      monitorVisible: false,
      monitorVisible1: false,
      applicationNumber: "",
      stage1: "",
      timer: "",
      watchNum: 0,
      personDialog: false,
      form1: {},
      peopleList: [],
      totalAmount: 0,
      totalNum: 0,
      loading2: false,
      selectedItem1: [],
      selectedItem2: [],
      selectedItem3: [],
      ids: "",
      monitorType: "",
      //查询费用详情
      feeToken:"",
      feeSign:"",
      feeSipoId:"",
      queCount:0,
    };
  },
  created() {
    //  this.getObjectData()
  },
  mounted() {
    this.getObjectData();
    // this.getIndexData()
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  components: {
    searchBar,
  },
  watch: {
    search(val) {
      this.getSuggest(val);
    },
    page() {
      this.getMonitorData();
    },
  },
  methods: {
    ...mapActions("search", ["querySug"]),
    ...mapActions("manager", [
      "getMonitorList",
      "getOpObject",
      "addOpObject",
      "getMonitorIndex",
      "getMonitorChart",
      "downLoadData",
      "annualFeeInfo",
      "addMonitorPatent",
      "getNotifyPerList",
      "addNotifyPerson",
      "downLoadFeedata",
      "monitorPatentDel",
      "getFeeInfoParam",
      "getInfo",
      "addQueue",
    ]),
    getSuggest(val) {
      this.compName = val;
      let _this = this;
      let data = {
        params: {
          q: val,
        },
      };
      this.querySug({
        data: data,
        handle(res) {
          let data = res.data;
          let newData = [];
          if (data && data.length > 0) {
            data.forEach((item) => {
              newData.push(item.text);
            });
          }
          _this.compNameItems = newData;
        },
      });
    },
    numChange(val) {
      this.activeKey = val;
      this.tabChange(val);
    },
    tabChange(val) {
      clearTimeout(this.timer);
      this.page = 1;
      this.setKey();
      if (val == "0") {
        this.getIndexData();
      } else {
        this.getMonitorData();
      }
      //全部op=0 申请中 stage=applying m= applying 有效： granted 失效： invalid 放弃： giveup
    },
    datePickChange(val) {
      if (val == 1) {
        this.menu1 = false;
      }
      if (val == 2) {
        this.menu2 = false;
      }
      if (val == 3) {
        this.menu3 = false;
      }
      if (val == 4) {
        this.menu4 = false;
      }
      if (val == 5) {
        this.menu5 = false;
      }
      if (val == 6) {
        this.menu6 = false;
      }
      if (val == 7) {
        this.menu7 = false;
      }
      if (val == 8) {
        this.menu8 = false;
      }
      this.page = 1;
      this.setKey();
      this.getMonitorData();
    },
    dateChange(val) {
      if (val == "appDate1") {
        this.appDate1.date = [];
      }
      if (val == "feeDate1") {
        this.feeDate1.date = [];
      }
      if (val == "appDate2") {
        this.appDate2.date = [];
      }
      if (val == "feeDate2") {
        this.feeDate2.date = [];
      }
      if (val == "appDate3") {
        this.appDate3.date = [];
      }
      if (val == "feeDate3") {
        this.feeDate3.date = [];
      }
      if (val == "appDate4") {
        this.appDate4.date = [];
      }
      if (val == "appDate5") {
        this.appDate5.date = [];
      }
      this.page = 1;
      this.setKey();
      this.getMonitorData();
    },
    setKey() {
      if (this.activeKey == "1") {
        this.monitorStatus = "";
        this.stage = this.status1;
        this.m = this.status1;
        this.patentType = this.type1;
        this.filterKey = this.filKey1;
        this.applicationDateStart = "";
        this.applicationDateEnd = "";
        this.deadlineStart = "";
        this.deadlineEnd = "";
        if (this.appDate1.date && this.appDate1.date.length > 0) {
          this.applicationDateStart = this.appDate1.date[0];
          this.applicationDateEnd = this.appDate1.date[1];
        }
        if (this.feeDate1.date && this.feeDate1.date.length > 0) {
          this.deadlineStart = this.feeDate1.date[0];
          this.deadlineEnd = this.feeDate1.date[1];
        }
      }
      if (this.activeKey == "2") {
        this.monitorStatus = "MONITOR";
        this.stage = this.status2;
        this.m = this.status2;
        this.patentType = this.type2;
        this.filterKey = this.filKey2;
        this.applicationDateStart = "";
        this.applicationDateEnd = "";
        this.deadlineStart = "";
        this.deadlineEnd = "";
        if (this.appDate2.date && this.appDate2.date.length > 0) {
          this.applicationDateStart = this.appDate2.date[0];
          this.applicationDateEnd = this.appDate2.date[1];
        }
        if (this.feeDate2.date && this.feeDate2.date.length > 0) {
          this.deadlineStart = this.feeDate2.date[0];
          this.deadlineEnd = this.feeDate2.date[1];
        }
      }
      if (this.activeKey == "3") {
        this.monitorStatus = "MONITORING";
        this.stage = this.status3;
        this.m = this.status3;
        this.patentType = this.type3;
        this.filterKey = this.filKey3;
        this.applicationDateStart = "";
        this.applicationDateEnd = "";
        this.deadlineStart = "";
        this.deadlineEnd = "";
        if (this.appDate3.date && this.appDate3.date.length > 0) {
          this.applicationDateStart = this.appDate3.date[0];
          this.applicationDateEnd = this.appDate3.date[1];
        }
        if (this.feeDate3.date && this.feeDate3.date.length > 0) {
          this.deadlineStart = this.feeDate3.date[0];
          this.deadlineEnd = this.feeDate3.date[1];
        }
      }
      if (this.activeKey == "4") {
        this.stage = "invalid";
        this.m = "invalid";
        this.patentType = this.type4;
        this.filterKey = this.filKey4;
        this.applicationDateStart = "";
        this.applicationDateEnd = "";
        this.deadlineStart = "";
        this.deadlineEnd = "";
        if (this.appDate4.date && this.appDate4.date.length > 0) {
          this.applicationDateStart = this.appDate4.date[0];
          this.applicationDateEnd = this.appDate4.date[1];
        }
      }
      if (this.activeKey == "5") {
        this.stage = "giveup";
        this.m = "giveup";
        this.patentType = this.type5;
        this.filterKey = this.filKey5;
        this.applicationDateStart = "";
        this.applicationDateEnd = "";
        this.deadlineStart = "";
        this.deadlineEnd = "";
        if (this.appDate5.date && this.appDate5.date.length > 0) {
          this.applicationDateStart = this.appDate5.date[0];
          this.applicationDateEnd = this.appDate5.date[1];
        }
      }
    },
    filterKeyChange() {
      this.page = 1;
      this.setKey();
      this.getMonitorData();
    },
    getIndexData() {
      let keyWord = this.keyWord;
      if (this.keyWord == "-1") {
        keyWord = "";
      }
      clearTimeout(this.timer);
      let data = {
        params: {
          applicationId: keyWord,
        },
      };
      let _this = this;
      this.loading1 = true;
      this.getMonitorIndex({
        data: data,
        handle(res) {
          _this.$nextTick(() => {
            _this.initChart();
          });
          if (res.code == 0) {
            _this.loading1 = false;
            _this.numInfo = res.stageMap;
            _this.numTotal = res.total;
            if (res.data1 && res.data1.length > 0) {
              res.data1.forEach((item) => {
                item.name = item.key;
              });
            } else {
              res.data1 = [];
            }
            let data2Total = 0;
            if (res.data2 && res.data2.length > 0) {
              res.data2.forEach((item) => {
                data2Total = data2Total + item.value;
              });
              res.data2.forEach((item) => {
                item.percent = (item.value / data2Total).toFixed(2) * 100;
              });
            } else {
              res.data2 = [];
            }
            if (res.data3 && res.data3.length > 0) {
              res.data3.forEach((item) => {
                item.name = item.key;
              });
            } else {
              res.data3 = [];
            }
            if (res.data4 && res.data4.length > 0) {
              res.data4.forEach((item) => {
                item.name = item.key;
              });
            } else {
              res.data4 = [];
            }
            if (res.data5 && res.data5.length > 0) {
              res.data5.forEach((item) => {
                item.name = item.key;
              });
            } else {
              res.data5 = [];
            }
            if (res.data6 && res.data6.length > 0) {
              res.data6.forEach((item) => {
                item.name = item.key;
              });
            } else {
              res.data6 = [];
            }
            let x1 = [];
            if (res.data7_1 && res.data7_1.length > 0) {
              res.data7_1.forEach((item) => {
                x1.push(item.key);
                item.name = item.key;
              });
            }
            let x2 = [];
            if (res.data7_2 && res.data7_2.length > 0) {
              res.data7_2.forEach((item) => {
                x2.push(item.key);
                item.name = item.key;
              });
            }
            let x3 = x1.concat(x2);
            let x = [];
            x3.forEach((item) => {
              if (x.indexOf(item) < 0) {
                x.push(item);
              }
            });
            if (x && x.length > 0) {
              x.forEach((item) => {
                let year = item;
                let flag = false;
                let flag1 = false;
                res.data7_1.forEach((item1) => {
                  if (item1.key == year) {
                    flag = true;
                  }
                });
                if (!flag) {
                  res.data7_1.push({
                    key: year,
                    name: year,
                    value: 0,
                  });
                }
                res.data7_2.forEach((item2) => {
                  if (item2.key == year) {
                    flag1 = true;
                  }
                });
                if (!flag1) {
                  res.data7_2.push({
                    key: year,
                    name: year,
                    value: 0,
                  });
                }
              });
            }
            x.sort((a, b) => {
              return a - b;
            });
            res.data7_1.sort((a, b) => {
              return a.name - b.name;
            });
            res.data7_2.sort((a, b) => {
              return a.name - b.name;
            });
            _this.dataAxis = x;
            _this.data1 = res.data1;
            _this.data2 = res.data2;
            _this.data3 = res.data3;
            _this.data4 = res.data5;
            _this.data5 = res.data4;
            _this.data6 = res.data6;
            _this.data7 = [
              {
                name: "申请",
                list: res.data7_1,
              },
              {
                name: "授权",
                list: res.data7_2,
              },
            ];
            setTimeout(() => {
              _this.renderChart();
            }, 600);
          } else {
            _this.initData();
            if (res.code == "303") {
              _this.loading1 = true;
              if (res.message == "添加管理对象") {
                _this.tipsInfo = "正在审核中，请联系我们的客服";
                _this.$message({
                  type: "info",
                  message: "正在审核中，请联系我们的客服",
                });
              } else {
                _this.tipsInfo = res.message;
                _this.$message({
                  type: "info",
                  message: res.message,
                });
                _this.queryIndexData();
              }
            } else {
              _this.loading1 = false;
              _this.$message({
                type: "info",
                message: res.message,
              });
            }
            _this.renderChart();
          }
        },
      });
    },
    queryIndexData() {
      this.timer = setTimeout(() => {
        this.getIndexData();
      }, 60000);
    },
    getMonitorData() {
      let info = {
        op: 0,
        d: -1,
        m: this.m,
        stage: this.stage,
        page: this.page,
        // applicationId: '',
        applicationDateStart: this.applicationDateStart,
        applicationDateEnd: this.applicationDateEnd,
        deadlineStart: this.deadlineStart,
        deadlineEnd: this.deadlineEnd,
        patentType: this.patentType,
        keyword: this.filterKey,
        pageSize: this.pageSize,
        monitorStatus: this.monitorStatus,
        // companyId: ''
      };
      if (this.keyWord && this.keyWord != "-1") {
        info.applicationId = this.keyWord;
      } else {
        info.applicationId = "";
      }
      let data = {
        params: info,
      };
      let _this = this;
      this.list = [];
      this.loading = true;
      this.getMonitorList({
        data: data,
        handle(res) {
          _this.loading = false;
          if (res.code == "0") {
            _this.list = res.pagination.data || [];
            _this.totalNum = res.pagination.total;
            _this.totalAmount = res.sumAmount;
            _this.total = res.pagination.total;
            _this.length = res.pagination.totalPages;
            if (_this.activeKey == 1) {
              let c1 = res.stageMap.APPLYING ? res.stageMap.APPLYING : 0;
              let c2 = res.stageMap.GRANTED ? res.stageMap.GRANTED : 0;
              _this.numCalc = c1 + c2;
            } else {
              _this.numCalc = res.pagination.total;
            }
          }
        },
      });
    },
    getObjectData() {
      let data = {};
      let _this = this;
      this.itemLoading = true;
      this.getOpObject({
        data: data,
        handle(res) {
          _this.itemLoading = false;
          if (res.success) {
            _this.compItems = res.model.pagination.data;
            let list = res.model.pagination.data;
            if (_this.compItems.length > 0) {
              list.unshift({ id: "-1", name: "全部管理对象" });
              _this.compItems = list;
              _this.keyWord = _this.compItems[0].id;
              _this.getIndexData();
            }
          }
        },
      });
    },
    exportAll() {
      let info = {
        op: 0,
        d: -1,
        m: this.m,
        stage: this.stage,
        page: this.currentpage,
        // applicationId: '',
        applicationDateStart: this.applicationDateStart,
        applicationDateEnd: this.applicationDateEnd,
        patentType: this.patentType,
        keyword: this.filterKey,
        pageSize: this.pageSize,
        monitorStatus: this.monitorStatus
        // companyId: ''
      };
      if (this.keyWord) {
        info.applicationId = this.keyWord;
      }
      let data = {
        params: info,
      };
      let _this = this;
      this.downLoadData({
        data: data,
        handle(res) {
          if (res.success || res.code == "0") {
            _this.$message({
              type: "success",
              message: res.message,
            });
            let path = res.filePath;
            window.location.href =
              _this.$store.state.baseUrl + "/export/download?path=" + path;
          } else {
            _this.$message({
              type: "info",
              message: res.message,
            });
          }
        },
      });
    },
    feeExport() {
      this.setKey();
      this.getDownLoadFee();
    },
    getDownLoadFee() {
      let info = {
        op: 0,
        d: -1,
        m: this.m,
        stage: this.stage,
        // page: this.page,
        applicationId: this.keyWord,
        applicationDateStart: this.applicationDateStart,
        applicationDateEnd: this.applicationDateEnd,
        deadlineStart: this.deadlineStart,
        deadlineEnd: this.deadlineEnd,
        patentType: this.patentType,
        keyword: this.filterKey,
        // pageSize: this.pageSize,
        monitorStatus: this.monitorStatus,
      };
      let data = {
        params: info,
      };
      let _this = this;
      this.downLoadFeedata({
        data: data,
        handle(res) {
          if (res.success || res.code == "0") {
            _this.$message({
              type: "success",
              message: res.message,
            });
            let path = res.filePath;
            window.location.href =
              _this.$store.state.baseUrl + "/export/download?path=" + path;
          } else {
            _this.$message({
              type: "info",
              message: res.message,
            });
          }
        },
      });
    },
    getKey(val) {},
    selAllObject() {
      this.keyWord = "";
      this.compChange();
    },
    compChange() {
      if (this.activeKey == "0") {
        this.initData();
      }
      this.page = 1;
      this.getMonitorData();
      this.getIndexData();
    },
    initData() {
      this.numTotal = 0;
      this.numInfo = {};
      this.dataAxis = [];
      this.data1 = [];
      this.data2 = [];
      this.data3 = [];
      this.data4 = [];
      this.data5 = [];
      this.data6 = [];
      this.data7 = [];
    },
    addManager() {
      this.addDialog = true;
    },
    handleAddOk() {
      let data = {
        params: {
          name: this.compName,
        },
      };
      let _this = this;
      this.addOpObject({
        data: data,
        handle(res) {
          _this.addDialog = false;
          _this.activeKey = 0;
          if (res.success) {
            _this.$message({
              type: "success",
              message: res.message,
            });
            _this.getObjectData();
          } else {
            _this.$message({
              type: "info",
              message: res.message,
            });
          }
        },
      });
    },
    handleAddCancel() {
      this.addDialog = false;
    },
    initChart() {
      if (document.getElementById("dom1")) {
        this.myChart1 = echarts.init(document.getElementById("dom1"));
      }
      if (document.getElementById("dom3")) {
        this.myChart3 = echarts.init(document.getElementById("dom3"));
      }
      if (document.getElementById("dom4")) {
        this.myChart4 = echarts.init(document.getElementById("dom4"));
      }
      if (document.getElementById("dom5")) {
        this.myChart5 = echarts.init(document.getElementById("dom5"));
      }
      if (document.getElementById("dom6")) {
        this.myChart6 = echarts.init(document.getElementById("dom6"));
      }
      if (document.getElementById("dom7")) {
        this.myChart7 = echarts.init(document.getElementById("dom7"));
      }
      window.addEventListener("resize", () => {
        this.myChart1.resize();
        this.myChart3.resize();
        this.myChart4.resize();
        this.myChart5.resize();
        this.myChart6.resize();
        this.myChart7.resize();
      });
    },
    renderChart() {
      this.pieChart(this.myChart1, "专利", this.data1);
      this.pieChart1(this.myChart3, "专利类型", this.data3);
      this.pieChart1(this.myChart4, "核心技术", this.data4);
      this.barChart(this.myChart5, "当前法律状态", this.data5);
      this.pieChart2(this.myChart6, "发明人", this.data6);
      this.setChart1(this.myChart7, "申请/授权", this.data7);
    },
    pieChart(mychart, name, data) {
      let option = {
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          show: false,
          // orient: 'vertical',
          // left: 'left',
        },
        grid: {
          bottom: 0,
        },
        series: [
          {
            name: name,
            type: "pie",
            radius: "50%",
            bottom: 0,
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      mychart.setOption(option);
    },
    pieChart1(mychart, name, data) {
      let option = {
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          show: false,
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: name,
            type: "pie",
            radius: ["40%", "70%"],
            // avoidLabelOverlap: false,
            bottom: 0,
            label: {
              show: true,
              position: "outside",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold",
                position: "center",
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            labelLine: {
              // show: true,
            },
            data: data,
          },
        ],
      };
      mychart.setOption(option);
    },
    pieChart2(mychart, name, data) {
      let option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        legend: {
          show: false,
          top: "bottom",
        },
        toolbox: {
          show: false,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        series: [
          {
            name: name,
            type: "pie",
            radius: ["20%", "75%"],
            center: ["50%", "50%"],
            roseType: "area",
            itemStyle: {
              borderRadius: 8,
            },
            data: data,
          },
        ],
      };
      mychart.setOption(option);
    },
    barChart(mychart, name, data) {
      let option = {
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["2011年", "2012年"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "0",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          // boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: "category",
          data: ["授权", "驳回", "权利终止", "实质审查", "公开", "撤回"],
        },
        series: [
          {
            name: name,
            type: "bar",
            data: data,
          },
        ],
      };
      mychart.setOption(option);
    },
    setChart1(myChart, name, data) {
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.dataAxis,
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#777C8B",
            },
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        color: [
          "#5AC6A8",
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#777C8B",
            },
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        series: [
          {
            name: data[0].name,
            data: data[0].list,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#5AC6A8", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#7fcaff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
          {
            name: data[1].name,
            data: data[1].list,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#0095ff", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#7fcaff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    watchPatent(val) {
      this.feeData1 = [];
      this.feeData2 = [];
      this.feeInfo = val;
      this.feeDialog = true;
      this.feeLoading = true;
      this.applicationNumber = val.applicationNumber;
      let _this = this;
      this.queCount = 0;
      // this.getFeeInfoParam({
      //   data: data,
      //   handle(res) {
      //     if (res.code == "0") {
      //       _this.feeToken = res.value.t;
      //       _this.feeSign = res.value.sign;
      //       _this.feeSipoId = res.value.sipoId;
            _this.getInfoMsg();
        //   } else {
        //     _this.$message({
        //       type: "info",
        //       message: res.message,
        //     });
        //   }
        // },
      // });
    },
    getInfoMsg(){
      // let param = {
      //     sipoId: this.feeSipoId,
      //     type: 2,
      //   }
      //   param = Qs.stringify(param)
      //   console.log("param",param);
      //   let data1 = {
      //       param: param,
      //       head: {
      //           headers: {
      //               'token': this.feeToken
      //           } 
      //       } 
      //   }
      //   this.getInfo({data: data1,handle: this.getInfoMsgTips})
      let data = {
        params: {
          applicationNumber: this.applicationNumber
        },
      };
      this.annualFeeInfo({data: data,handle: this.getInfoMsgTips})
    },
    getInfoMsgTips(res) {
      console.log("info",res.value);
      if(res.code!=404&&res.code!=0){
        this.$message({
          type: "info",
          message: res.message,
        })
      }else{
        if (res.value) {
                let list = res.value.FeeInfo;
                let data1 = [];
                list.forEach((item) => {
                  if (item.type == "应缴费信息") {
                    data1.push(item);
                  }
                });
                data1.sort((a, b) => {
                  return new Date(a.date).getTime() - new Date(b.date).getTime();
                });
                let data2 = [];
                list.forEach((item) => {
                  if (item.type == "已缴费信息") {
                    data2.push(item);
                  }
                });
                data2.sort((a, b) => {
                  return new Date(a.date).getTime() - new Date(b.date).getTime();
                });
                this.feeData1 = data1;
                this.feeData2 = data2;
                this.feeLoading = false;
            }else {
                // if(this.queCount<1) {
                //     let arr = []
                //     arr.push(this.feeSipoId)
                //     let info = {
                //         ids: arr,
                //         type: 0,
                //         level: 5
                //     }
                //     let _this = this
                //     this.addQueue({data: info,
                //     handle: function (res) {
                //         _this.queCount++;
                //         if (res.code === 0) {
                //             // _this.$message.info(res.msg)
                //         }else {
                //             _this.$message.info(res.msg)
                //         }
                //     }})
                // }
                  this.queCount++;
                  if(this.queCount>20){
                    this.queCount=0;
                    this.feeLoading = false;
                    this.$message.info(res.message)
                  }else{
                    this.timer1 = setTimeout(() => {
                              this.getInfoMsg()
                          }, 3000);
                        }
                }
                
      }
            

    },
    goSetting() {
      this.$router.push({
        path: "/manager/setting",
      });
    },
    goMsgSet() {
      this.$router.push({
        path: "/manager/msgset",
      });
    },
    handleFeeCancel() {
      this.feeDialog = false;
    },
    timeFormat(unixTime) {
      let date = new Date(unixTime);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      return Y + M + D;
    },
    goDetail(items) {
      let id = items.documentNumber;
      let routeUrl = this.$router.resolve({
        path: "/search/patentInfo/" + id,
        query: {
          from: "space",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    monitorPatent(val) {
      this.monitorType = "MONITOR";
      let ids = "";
      // if (this.stage) {
      //   this.stage1 = JSON.parse(JSON.stringify(this.stage)).toUpperCase()
      // }
      this.addMonitor(ids);
      // if (this.numCalc > 5) {
      //   this.monitorVisible = true;
      // } else {
      //   //接口
      //
      // }
    },
    singleMonitor(item) {
      this.numCalc = 1;
      let ids = item.id;
      this.monitorType = "MONITOR";
      this.addMonitor(ids);
    },
    batchMonitor(res) {
      if (res.length <= 0) {
        this.$message({
          type: "info",
          message: "请选中专利",
        });
        return false;
      }
      let idList = res.map((item) => {
        return item.id;
      });
      let ids = idList.join(",");
      this.monitorType = "MONITOR";
      this.addMonitor(ids);
    },
    batchCancel(res) {
      if (res.length <= 0) {
        this.$message({
          type: "info",
          message: "请选中专利",
        });
        return false;
      }
      let idList = res.map((item) => {
        return item.id;
      });
      let ids = idList.join(",");
      this.monitorType = "MONITORING";
     this.addMonitor(ids);
    },
    singleCancel(id) {
      console.log("id", id);
      this.monitorType = "MONITORING";
      this.addMonitor(id);
    },
    addMonitor(ids) {
      let info = {
        op: 0,
        d: -1,
        m: this.m,
        stage: this.stage,
        page: this.page,
        applicationId: this.keyWord,
        applicationDateStart: this.applicationDateStart,
        applicationDateEnd: this.applicationDateEnd,
        deadlineStart: this.deadlineStart,
        deadlineEnd: this.deadlineEnd,
        patentType: this.patentType,
        keyword: this.filterKey,
        pageSize: this.pageSize,
        monitorStatus: this.monitorStatus,
        type: this.monitorType,
        ids: ids,
      };
      let data = {
        params: info,
      };
      this.loading = true;
      this.loading2 = true;
      // let data = {
      //   params: {
      //     applicationId: this.keyWord,
      //     stage: this.stage1,
      //     applicationNumber: this.applicationNumber,
      //     // total: parseInt(this.numCalc)
      //   },
      // }
      let _this = this;
      this.addMonitorPatent({
        data: data,
        handle(res) {
          _this.loading = false;
          _this.loading2 = false;
          if (res.success) {
            if (_this.monitorType == "MONITORING") {
              _this.$message({
                type: "success",
                message: res.message,
              });
              console.log(res.message)
              _this.tipMessage=res.message
            } else {
              if (res.updateNum > 0) {
                _this.watchNum = res.updateNum;
                _this.residueNum =res.residueNum
                _this.monitorVisible1 = true;
                _this.getPersonList();
              }
            }
            _this.getMonitorData();
          } else {
            if (res.code == 7200) {
              _this.monitorVisible = true;
            }
            if (res.message) {
              _this.$message({
                type: "info",
                message: res.message,
              });
              _this.tipMessage=res.message
            }
          }
        },
      });
    },
    batchDelete(res) {
      if (res.length <= 0) {
        this.$message({
          type: "info",
          message: "请选中专利",
        });
        return false;
      }
      let idList = res.map((item) => {
        return item.id;
      });
      let ids = idList.join(",");
      console.log("ids", ids);
      this.deletePatent(ids);
    },
    singleDelete(id) {
      this.deletePatent(id);
    },
    deletePatent(ids) {
      this.$msgbox
        .confirm("此操作将删除该专利, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let data = {
            params: {
              ids: ids,
            },
          };
          let _this = this;
          this.monitorPatentDel({
            data: data,
            handle(res) {
              if (res.success) {
                _this.$message({
                  type: "success",
                  message: res.message,
                });
                _this.getMonitorData();
              } else {
                _this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getPersonList() {
      let data = {};
      let _this = this;
      this.getNotifyPerList({
        data: data,
        handle(res) {
          if (res.code == "0") {
            _this.peopleList = res.targetList;
          } else {
            _this.$message({
              type: "info",
              message: res.message,
            });
          }
        },
      });
    },
    addObject() {
      this.form1 = {};
      // this.personDialog = true
      this.goMsgSet();
    },
    handlePersonAddOk() {
      if (!this.form1.name) {
        this.$message({
          type: "info",
          message: "请输入通知人信息",
        });
        return false;
      }
      if (!this.form1.email) {
        this.$message({
          type: "info",
          message: "请输入通知人邮箱",
        });
        return false;
      } else {
        let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!reg.test(this.form1.email)) {
          this.$message({
            type: "info",
            message: "请输入正确的邮箱地址",
          });
          return false;
        }
      }
      if (this.form1.webChat) {
        let reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (!reg.test(this.form1.webChat)) {
          this.$message({
            type: "info",
            message: "请输入正确的手机号",
          });
          return false;
        }
      }
      let data = {
        params: this.form1,
      };
      let _this = this;
      this.addNotifyPerson({
        data: data,
        handle(res) {
          _this.personDialog = false;
          if (res.success) {
            _this.$message({
              type: "success",
              message: res.message,
            });
            _this.getPersonList();
          } else {
            _this.$message({
              type: "info",
              message: res.message,
            });
          }
        },
      });
    },
    handlePersonCancel() {
      this.form1 = {};
      this.personDialog = false;
    },
  },
};
</script>
